<div class="uk-grid uk-grid-small">
    <div class="uk-width-large-2-3">
        <app-flat-card class="tw-mb-2 tw-flex tw-justify-between">
            <div *ngIf="steps[currentStep - 1] as stepInfo">
                <h4 class="tw-m-0">{{ stepInfo.title }}</h4>
                <p class="tw-text-gray-400 tw-m-0">{{ stepInfo.subTitle }}</p>
            </div>
            <app-stepper [currentStep]="currentStep" [totalSteps]="Object.values(steps).length"></app-stepper>
        </app-flat-card>
        <app-flat-card>
            <div class="tw-my-4">
                <!-- first step -->
                <app-payment-list *ngIf="currentStep === 1" (onReady)="goNextStep()"></app-payment-list>

                <!-- second step -->
                <ng-container *ngIf="commission$ | async as total">
                    <app-payment-methods
                        *ngIf="currentStep === 2"
                        [totalPayment]="+total.totalWithCommission"
                        (onReady)="goNextStep()"
                        (onBack)="goBackStep()"
                    ></app-payment-methods>
                </ng-container>

                <app-payment-visa *ngIf="currentStep === 3" (onError)="currentStep = 1"></app-payment-visa>
            </div>
        </app-flat-card>
    </div>

    <div class="uk-width-large-1-3">
        <app-flat-card>
            <div class="mb-1">
                <a class="uk-button" routerLink="/state/debts"> Ir al estado de deudas </a>
            </div>
            <app-payment-recomendations></app-payment-recomendations>
        </app-flat-card>
    </div>
</div>
